import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Box, Button, Heading, Image, Text, VStack } from "@chakra-ui/react";

import { RoutesMap } from "../../routes.tsx";
import errorIcon from "../../assets/cardError.png";
import { SessionStorageKeys } from "../../constants";

enum EParamPaymentType {
  Card = "card",
  Sbp = "sbp",
}

export function AddPaymentErrorPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const [paymentType, setPaymentType] = useState<EParamPaymentType | null>(null);

  const onTryAgain = () => {
    sessionStorage.removeItem(SessionStorageKeys.addPaymentMethodProcessed);

    let path;

    switch (paymentType) {
      case EParamPaymentType.Card:
        path = RoutesMap.cards.addCard;
        break;
      case EParamPaymentType.Sbp:
        path = RoutesMap.cards.addSbp;
        break;
      default:
        path = RoutesMap.index;
    }

    navigate(path);
  };

  useEffect(() => {
    const type = searchParams.get("paymentType");
    setPaymentType(type as EParamPaymentType);

    window.history.replaceState({}, "", window.location.pathname);
  }, []);

  return (
    <VStack h="100svh" pt="100px" spacing={0}>
      <Image boxSize="173px" src={errorIcon} mb="10px" />

      <Heading>Не удалось привязать</Heading>
      <Heading mt="-2px" mb="7px">способ оплаты</Heading>

      <Box color="gray.600" textAlign="center">
        <Text>Проверьте баланс, статус карты</Text>
        <Text>и попробуйте еще раз или добавьте</Text>
        <Text>другой способ оплаты</Text>
      </Box>

      <Button w="300px" mt="27px" colorScheme="brand" onClick={onTryAgain}>
        Попробовать еще раз
      </Button>

      <Button w="300px" mt="8px" colorScheme="purple" onClick={() => { navigate(RoutesMap.index); }}>
        Вернуться на главную
      </Button>
    </VStack>
  );
}
